<template>
  <div id="app">
    <router-view />
    <van-tabbar v-if="showTabbar" route active-color="#ff4d4f" inactive-color="#999">
      <van-tabbar-item to="/" icon="home-o">首页</van-tabbar-item>
      <van-tabbar-item to="/points-mall" icon="gift-o">积分商城</van-tabbar-item>
      <van-tabbar-item to="/cart" icon="shopping-cart-o">购物车</van-tabbar-item>
      <van-tabbar-item to="/mine" icon="user-o">我的</van-tabbar-item>
    </van-tabbar>
    <!-- 直播悬浮入口，直播开启时显示 -->
    <div class="live-entry" v-if="showLiveEntry" @click="$router.push('/live')">
      <van-icon name="video-o" />
      <span>直播中</span>
    </div>
    <!-- 聊天悬浮入口 -->
    <ChatFloatEntry />
    <!-- AI智能客服悬浮入口 -->
    <AiChatFloat />
  </div>
</template>

<script>
import ChatFloatEntry from './components/chat/ChatFloatEntry.vue'
import AiChatFloat from './components/ai/AiChatFloat.vue'

export default {
  components: { ChatFloatEntry, AiChatFloat },
  computed: {
    showTabbar() {
      const path = this.$route.path
      return ['/', '/points-mall', '/cart', '/mine'].includes(path)
    },
    showLiveEntry() {
      // 非直播页面且直播开启时显示
      return this.$route.path !== '/live' && this.$store.state.liveOpen
    }
  }
}
</script>

<style>
#app {
  width: 100%;
  height: 100%;
}
</style>
